require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#71B790',
        primary2: '#384967',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#018f27',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#71B790',
        primary2: '#384967',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#018f27',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
